import DraggableStepCard from '../../DraggableStepCard';
import { getNotifyMemberViaEmailFromString } from './action-helpers';

export const content = ({ step }) => step.description;

export const getDescription = ({ step, t }) => {
  const { details } = step;
  const subject = details?.email?.subject || '';
  return t('Email ‘{{subject}}’ to {{recipient}}', {
    subject,
    recipient: getNotifyMemberViaEmailFromString(details.teamMember, t),
  });
};

export default function NotifyMemberViaEmailCard({ step, ...others }) {
  return <DraggableStepCard {...others}>{content({ step })}</DraggableStepCard>;
}
